import { rateSchema } from "./rate";
import { createZodDto } from "nestjs-zod/dto";

const createRateSchema = rateSchema.pick({
  name: true,
  price: true,
  credit: true,
  aiPoints: true,
  hasTraduction: true,
  hasScoringAts: true,
  validity: true,
  description: true,
  isRecommended: true,
  type: true,
});

export class CreateRateDto extends createZodDto(createRateSchema) {}
